import { EmailAddress } from './email-address.model';
import { PhoneNumber } from './phone-number.model';
import { Moment } from 'moment';

export interface BusinessPerson {
  businessPersonId: number;
  customerId: number;
  personId: number;
  firstName: string;
  lastName: string;
  phoneNumbers: PhoneNumber[];
  emailAddresses: EmailAddress[];
  hasAcknowledged: boolean | null;
}

export interface StaffGroupBusinessPerson {
  staffGroupId: number;
  staffGroupName: string;
  staffGroupRank: number;
  businessPersonDtos: BusinessPerson[];
}

export interface ProfileBusinessPerson {
  readonly businessPersonId: number | null;
  departmentId: number | null;
  primaryCompanyAddressId: number | null;
  hrTitle: string | null;
  employeeId: string | null;
  initials: string | null;
  canpassCertificateNumber: string | null;
  certificateNumber: string | null;
}

export interface StaffBusinessPerson extends BusinessPerson {
  maxDutyHours: number;
  monthToDateHours: number;
  yearToDateHours: number;
  ron: number;
}

export enum FlightBusinessPersonType {
  UNKNOWN_FLIGHT_BUSINESS_PERSON_TYPE = 0,
  REQUESTER = 1,
  PLANNER = 2,
  APPROVER = 3
}
export interface BusinessPersonEvent {
  businessPerson: BusinessPerson | null;
  businessPersonId: number | null;
  eventType: string | null;
  eventName: string | null;
  startDateTime: Moment | string | null;
  endDateTime: Moment | string | null;
  staffEventId: number | null;
  aircraftEventId: number | null;
}
